import { configureStore } from '@reduxjs/toolkit'
import AppSlice from './appSlice'
import AuthReducer from './authSlice'
import G2Reducer from './g2Slice'

export const store = configureStore({
	reducer: {
		g2: G2Reducer,
		auth: AuthReducer,
		app: AppSlice,
	},
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
